import React, { useState, useEffect, forwardRef } from 'react';
import { motion } from 'framer-motion';

const advisors = [
  { name: 'Sarah Chen', role: 'CPA', location: 'San Diego', top: '18%', left: '8%' },
  { name: 'Marcus Rivera', role: 'Business Banker', location: 'Chase Bank', top: '42%', left: '52%' },
  { name: 'Priya Patel', role: 'HR Specialist', location: '12 yrs exp', top: '66%', left: '18%' },
];

export const Scene3 = forwardRef(function Scene3(props, ref) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 300),
      setTimeout(() => setPhase(2), 1000),
      setTimeout(() => setPhase(3), 1700),
    ];
    return () => timers.forEach(t => clearTimeout(t));
  }, []);

  return (
    <motion.div
      ref={ref}
      className="absolute inset-0 w-full h-full bg-[#F9F9F7]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.8 }}
    >
      <div className="absolute top-12 left-12 text-[#0D6B4B]">
        <motion.h2
          className="text-4xl font-bold"
          style={{ fontFamily: 'Playfair Display, serif' }}
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          Verified Advisors
        </motion.h2>
        <motion.p
          className="text-lg text-[#0D6B4B]/60 mt-1"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.4 }}
        >
          Ready to help your business grow
        </motion.p>
      </div>

      {advisors.map((adv, i) => (
        <motion.div
          key={i}
          className="absolute bg-white p-5 rounded-2xl shadow-xl border border-[#0D6B4B]/10 flex items-center gap-4"
          style={{ top: adv.top, left: adv.left, width: 300 }}
          initial={{ opacity: 0, y: 40, scale: 0.9 }}
          animate={phase >= (i + 1) ? { opacity: 1, y: 0, scale: 1 } : { opacity: 0, y: 40, scale: 0.9 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        >
          <div className="w-14 h-14 rounded-full bg-[#0D6B4B]/10 flex items-center justify-center text-[#0D6B4B] font-bold text-xl flex-shrink-0">
            {adv.name.charAt(0)}
          </div>
          <div>
            <div className="font-bold text-[#004D35] text-sm">{adv.name}</div>
            <div className="text-xs text-[#0D6B4B] font-semibold mt-0.5">{adv.role}</div>
            <div className="text-xs text-gray-400 mt-0.5">{adv.location}</div>
          </div>
          <div className="ml-auto">
            <span className="text-xs font-bold text-[#0D6B4B] bg-[#0D6B4B]/10 px-2 py-1 rounded-full">Verified</span>
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
});
